// ============================================================
// Dashboard Overview (New) — Remaining dummy/config data
// Live data is derived in hooks/useDashboardData.js
// ============================================================

import { appRoutes } from '@routes';

export const OVERALL_PRODUCTIVITY_DATA = {
  score: 82,
  label: 'Good',
  trendPct: 12,
  trendUp: true,
  teamAvg: 79,
};

export const KEY_HIGHLIGHTS_DATA = [
  {
    id: 'active-time',
    label: 'Active Time',
    value: '6h 32m',
    trendPct: 8,
    trendUnit: '%',
    trendUp: true,
    sublabel: '84%',
    sublabelSuffix: 'of tracked time',
    iconType: 'clock',
    iconBg: '#EEF4FF',
    iconColor: '#4F7EF8',
  },
  {
    id: 'idle-time',
    label: 'Idle Time',
    value: '1h 15m',
    trendPct: 18,
    trendUnit: '%',
    trendUp: false,
    sublabel: '16%',
    sublabelSuffix: 'of tracked time',
    iconType: 'coffee',
    iconBg: '#FFF6ED',
    iconColor: '#f59e0b',
  },
  {
    id: 'attendance',
    label: 'Attendance',
    value: '96%',
    trendPct: 4,
    trendUnit: '%',
    trendUp: true,
    sublabel: '27/28',
    sublabelSuffix: 'present',
    iconType: 'users',
    iconBg: '#ECFDF3',
    iconColor: '#22c55e',
  },
  {
    id: 'focus-time',
    label: 'Focus Time',
    value: '3h 48m',
    trendPct: 15,
    trendUnit: '%',
    trendUp: true,
    sublabel: '58%',
    sublabelSuffix: 'of tracked time',
    iconType: 'target',
    iconBg: '#EEF4FF',
    iconColor: '#4F7EF8',
  },
  {
    id: 'alerts',
    label: 'Alerts',
    value: '12',
    trendPct: 5,
    trendUnit: '',
    trendUp: true,
    sublabel: 'View all alerts',
    sublabelLink: true,
    sublabelTo: appRoutes().alerts,
    iconType: 'shield',
    iconBg: '#FFF1F3',
    iconColor: '#ef4444',
  },
];

// Show only key time labels on x-axis
export const PRODUCTIVITY_CHART_TICKS = [
  '12 AM',
  '4 AM',
  '8 AM',
  '12 PM',
  '4 PM',
  '8 PM',
  '12 AM',
];

// 7 days × 13 time slots — intensity 0.0–1.0 (used only as fallback reference)
const H = (v) => v;
export const ACTIVITY_HEATMAP_DATA = [
  {
    day: 'Mon',
    slots: [
      H(0.1),
      H(0.0),
      H(0.0),
      H(0.2),
      H(0.4),
      H(0.6),
      H(0.8),
      H(0.9),
      H(0.7),
      H(0.5),
      H(0.4),
      H(0.3),
      H(0.1),
    ],
  },
  {
    day: 'Tue',
    slots: [
      H(0.0),
      H(0.0),
      H(0.1),
      H(0.3),
      H(0.5),
      H(0.7),
      H(0.9),
      H(1.0),
      H(0.8),
      H(0.6),
      H(0.5),
      H(0.2),
      H(0.0),
    ],
  },
  {
    day: 'Wed',
    slots: [
      H(0.0),
      H(0.0),
      H(0.0),
      H(0.1),
      H(0.3),
      H(0.5),
      H(0.7),
      H(0.8),
      H(0.6),
      H(0.4),
      H(0.3),
      H(0.1),
      H(0.0),
    ],
  },
  {
    day: 'Thu',
    slots: [
      H(0.1),
      H(0.0),
      H(0.1),
      H(0.4),
      H(0.6),
      H(0.8),
      H(0.9),
      H(0.9),
      H(0.7),
      H(0.5),
      H(0.4),
      H(0.2),
      H(0.0),
    ],
  },
  {
    day: 'Fri',
    slots: [
      H(0.0),
      H(0.0),
      H(0.0),
      H(0.2),
      H(0.4),
      H(0.7),
      H(0.8),
      H(0.7),
      H(0.5),
      H(0.4),
      H(0.3),
      H(0.1),
      H(0.0),
    ],
  },
  {
    day: 'Sat',
    slots: [
      H(0.0),
      H(0.0),
      H(0.0),
      H(0.0),
      H(0.1),
      H(0.2),
      H(0.3),
      H(0.2),
      H(0.1),
      H(0.1),
      H(0.0),
      H(0.0),
      H(0.0),
    ],
  },
  {
    day: 'Sun',
    slots: [
      H(0.0),
      H(0.0),
      H(0.0),
      H(0.0),
      H(0.0),
      H(0.1),
      H(0.2),
      H(0.1),
      H(0.1),
      H(0.0),
      H(0.0),
      H(0.0),
      H(0.0),
    ],
  },
];
export const HEATMAP_TIME_LABELS = [
  '12 AM',
  '1 AM',
  '2 AM',
  '3 AM',
  '4 AM',
  '5 AM',
  '6 AM',
  '7 AM',
  '8 AM',
  '9 AM',
  '10 AM',
  '11 AM',
  '12 PM',
  '1 PM',
  '2 PM',
  '3 PM',
  '4 PM',
  '5 PM',
  '6 PM',
  '7 PM',
  '8 PM',
  '9 PM',
  '10 PM',
  '11 PM',
];

const sparkUp = [10, 25, 20, 40, 35, 55, 50];
const sparkMid = [30, 28, 35, 25, 40, 30, 38];
const sparkDown = [50, 42, 38, 30, 25, 20, 15];

// The Engineering department's actual 5 members (matching activeTeamId in
// EmployeeList.demoData.js / TeamList.demoData.js's headcount) — Team
// Dashboard's Key Highlights/ActivityBreakdown/TopApplications/
// FocusVsDistraction/AttendanceSummary are all computed as the SUM of these
// 5 rows' activeTime/idleTime/focusTime/attendance (see
// TeamDashboard.demoData.js), matching how production's backend
// consolidator sums per-member docs into one team-day total — so a change
// here must be reflected there too.
export const TEAM_PERFORMANCE_DATA = [
  {
    id: 'demo-user',
    name: 'Ryan Mitchell',
    role: 'Engineering Lead',
    avatar: 'RM',
    avatarBg: '#EEF4FF',
    avatarColor: '#4F7EF8',
    productivityScore: 88,
    scoreTrend: 5,
    scoreTrendUp: true,
    activeTime: '6h 30m',
    idleTime: '45m',
    focusTime: '4h 05m',
    attendance: '100%',
    attendanceStatus: 'Present',
    sparkline: sparkUp,
    sparkColor: '#22c55e',
  },
  {
    id: 'demo-emp-1',
    name: 'Rachel Turner',
    role: 'Engineering Manager',
    avatar: 'RT',
    avatarBg: '#ECFDF3',
    avatarColor: '#22c55e',
    productivityScore: 91,
    scoreTrend: 6,
    scoreTrendUp: true,
    activeTime: '7h 00m',
    idleTime: '50m',
    focusTime: '4h 35m',
    attendance: '100%',
    attendanceStatus: 'Present',
    sparkline: sparkUp,
    sparkColor: '#22c55e',
  },
  {
    id: 'demo-emp-2',
    name: 'Michael Chen',
    role: 'Frontend Developer',
    avatar: 'MC',
    avatarBg: '#FFF6ED',
    avatarColor: '#f59e0b',
    productivityScore: 76,
    scoreTrend: 4,
    scoreTrendUp: true,
    activeTime: '6h 15m',
    idleTime: '1h 05m',
    focusTime: '3h 45m',
    attendance: '100%',
    attendanceStatus: 'Late',
    sparkline: sparkMid,
    sparkColor: '#22c55e',
  },
  {
    id: 'demo-emp-7',
    name: 'Natalie Brooks',
    role: 'Backend Developer',
    avatar: 'NB',
    avatarBg: '#F4F3FF',
    avatarColor: '#7a5af8',
    productivityScore: 92,
    scoreTrend: 15,
    scoreTrendUp: true,
    activeTime: '7h 12m',
    idleTime: '45m',
    focusTime: '4h 32m',
    attendance: '100%',
    attendanceStatus: 'Present',
    sparkline: sparkUp,
    sparkColor: '#22c55e',
  },
  {
    id: 'demo-emp-10',
    name: 'Fatima Al-Sayed',
    role: 'QA Engineer',
    avatar: 'FA',
    avatarBg: '#FFF1F3',
    avatarColor: '#ef4444',
    productivityScore: 68,
    scoreTrend: 3,
    scoreTrendUp: false,
    activeTime: '5h 33m',
    idleTime: '1h 10m',
    focusTime: '3h 10m',
    attendance: '100%',
    attendanceStatus: 'Present',
    sparkline: sparkDown,
    sparkColor: '#f59e0b',
  },
];
